import { IonBadge, IonCol, IonGrid, IonIcon, IonItem, IonLabel, IonList, IonNote, IonRippleEffect, IonRow, IonSkeletonText, useIonRouter } from "@ionic/react";
import { t } from "i18next";
import { folderOutline } from "ionicons/icons";
import React from "react";
import { FileType, Folder } from "./index";

export const FolderView = (props: any) => {
  const router = useIonRouter();

  const navigate = (path: string) => {
    router.push(path);
  };

  return (
    <div className="folder-view">
      {!props.isPending && !props.contents.files?.length && !props.contents.subfolders?.length ? <IonNote>{t("emptyFolder")}</IonNote> : ""}

      {!props.isPending && props.contents.subfolders?.length ? (
        <IonGrid>
          <IonRow>
            {props.contents.subfolders.map((subfolder: Folder) => (
              <IonCol size={"6"} sizeLg={"3"} key={"subfolder-id-" + subfolder.id}>
                <div
                  className={"ion-activatable ripple-parent rounded-rectangle"}
                  onClick={() => {
                    navigate(`/resources/${subfolder.id}/${subfolder.title}`);
                  }}
                >
                  <IonRippleEffect></IonRippleEffect>
                  <IonIcon aria-hidden="true" icon={folderOutline} color={"dark"} size={"large"} />
                  <IonLabel
                    className={"block"}
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {subfolder.title}
                  </IonLabel>
                  <IonLabel
                    className={"block"}
                    style={{
                      fontSize: "0.8em",
                    }}
                  >
                    {subfolder.files_count} {subfolder.files_count === 1 ? t("file") : t("files")}
                  </IonLabel>
                </div>
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
      ) : (
        ""
      )}

      {props.isPending && (
        <IonGrid>
          <IonRow>
            {Array.from(Array(6).keys()).map((arr, index) => (
              <IonCol size={"6"} key={"subfolder-id-placeholder-" + index}>
                <div className={"ion-activatable--placeholder"}>
                  <IonSkeletonText
                    animated={true}
                    className={"ion-icon"}
                    style={{
                      width: "64px",
                      height: "64px",
                    }}
                  ></IonSkeletonText>
                  <IonSkeletonText
                    animated={true}
                    style={{
                      height: "1rem",
                    }}
                  />
                </div>
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
      )}

      {!props.isPending && props.contents.files?.length ? (
        <div className={"ion-margin-top"}>
          <h2>
            {t("files")} <IonBadge>{props.contents.files?.length || "0"}</IonBadge>
          </h2>

          <IonList>
            {props.contents.files.map((file: FileType) => (
              <IonItem
                key={`file-${file.id}`}
                button
                routerLink={"/files/" + file.id + "/" + file.title}
                style={{
                  "--padding-start": "2px",
                }}
              >
                {file.title}
              </IonItem>
            ))}
          </IonList>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
